module.exports = __webpack_public_path__ + "img/westendoverlook_thumb.ecc75d22.jpg";